import React from "react";
import Connector from "../../../redux/connector";
import PageBuilder from "../../../components/web/Common/PageBuilder";

class LeadSettingCategoryCommentPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        let StateStorage = [
            {stateField: "Data", moduleEntity: "lead/entity", table: "batch-category-comment", noCondition: false},
            {stateField: "Companies", moduleEntity: "client/entity", table: "company", noCondition: false},
        ];
        let displayListColumns = [
            {id: "Client", label: "Company"},
            {id: "Name", label: "Name"},
        ]
        let translateFields = [
            {
                keyName: "Client",
                keySearch: "CustomerNumber",
                keyValue: "Org",
                keyReturn: "Name",
                stateEntity: "Companies"
            }
        ];
        let entityOptions = [
        ];
        let bldOptions = [
            {
                label: "Name of Company",
                message: "Please select your  name",
                key: "CustomerNumber",
                value: "Name",
                lookInState: true,
                targetStorage: "Companies",
                StateKey: "Org"
            },
        ];
        let bldFields = [
            {
                label: "Name",
                message: "Please input your  name",
                type: "text",
                StateKey: "Name",
                required:true
            },
        ]
        return (
            <PageBuilder
                pageTitle={"Category of Comment"}
                StateStorage={StateStorage}
                displayListColumns={displayListColumns}
                displayTableKeyState={"Data"}
                hasTranslateField={true}
                translateFields={translateFields}
                entityOptions={entityOptions}
                bldOptions={bldOptions}
                bldFields={bldFields}
                newFormTitle={"New Comment Category"}
                postMsgResponse={"Thank you, category comment submitted!"}
                postMsgWarning={"Are you sure you want to submit this Category comment"}
                postEndpoint={"/lead/entity/insert/batch-category-comment"}
            />
        )
    }

}

export default Connector(LeadSettingCategoryCommentPage);

const styles = {
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
}
